import { Component, h } from 'preact';

class TopNews extends Component {
  render () {
    const timestamp = new Date(this.props.topNewsTimestamp);

    const hours = timestamp.getHours();
    let minutes = timestamp.getMinutes();
    if (String(minutes).length < 2) {
      minutes = `0${minutes}`;
    }
    const suffix = hours >= 12 ? 'PM' : 'AM';

    const time = `${hours > 12 ? hours - 12 : hours}:${minutes} ${suffix}`;

    const posts = this.props.posts.map((post, idx) => {
      return <li className="news-list__item" key={idx} dangerouslySetInnerHTML={{__html: post.value}}></li>;
    });

    let electionCoverageButton = null;

    if (this.props.includeElectionCoverageButton) {
      electionCoverageButton = <a className="button button--yellow" href="https://www.texastribune.org/2016/texas-elections/">View all election coverage &#187;</a>;
    }

    return (
      <div className="widget">
        <header className="widget__titlebar">
          <h2 className="widget__title">Top news</h2>
          <p className="widget__sub-title">Updated: <time>{time}</time></p>
        </header>
        <div className="widget__content">
          <ul className="news-list">
            {posts}
          </ul>
        </div>
        {electionCoverageButton}
      </div>
    );
  }
}

export default TopNews;



// WEBPACK FOOTER //
// ./components/top-news.js